import type { ReactElement } from "react";
import type { ResourceCategory } from "../types";
import { ArrowIcon } from "./ArrowIcon";

interface CategoryCardProps {
  category: ResourceCategory;
}

export const CategoryCard = ({ category }: CategoryCardProps): ReactElement => (
  <a className={`resources-category-card resources-category-card--${category.accent}`} href={category.href}>
    <div className="resources-category-card__content">
      <img alt="" aria-hidden="true" className="resources-category-card__icon" src={category.iconSrc} />
      <h3>{category.title}</h3>
      <p>{category.description}</p>
    </div>

    {category.imageSrc ? (
      <img alt={category.imageAlt || `${category.title} photography`} className="resources-category-card__photo" src={category.imageSrc} />
    ) : (
      <div aria-hidden="true" className="resources-category-card__photo resources-category-card__photo--placeholder" />
    )}
    <span className="resources-category-card__link">
      Explore <ArrowIcon size={16} />
    </span>
  </a>
);
